<template>
    <div class="content_box">
        <div class="content overview">
            <div class="top el_form">
                <div class="title">
                    <span>总览</span> &nbsp;&nbsp;
                    <el-select v-model="product_id" size="medium" placeholder="请选择">
                        <el-option :label="item.product_name" :value="item.product_id" v-for="item in product" :key="item.product_id + '123'"></el-option>
                    </el-select>
                </div>
                <div class="time_box">
                    <DatePicker :date="overviewTime" @dateSelect="dateSelect" :clearable="true"></DatePicker>
                </div>
            </div>
            <div class="area_box">
                <div class="order_number">
                    <div class="order_number_item">
                        <img class="order_img" src="../../../assets/images/overview/create.png" alt="">
                        <div class="order_data">
                            <p class="name">
                                <span>新建工单量</span> 
                                <el-tooltip popper-class="shadow" effect="light" content="筛选时间范围内，新创建的工单量" placement="bottom-start">
                                    <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                                </el-tooltip>
                            </p>
                            <p class="number_box">
                                <span class="number">{{formatNumber(orderData.create_count || 0)}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="order_number_item">
                        <img class="order_img" src="../../../assets/images/overview/assignee.png" alt="">
                        <div class="order_data">
                            <p class="name">
                                <span>受理中工单量</span> 
                                <el-tooltip popper-class="shadow" effect="light" content="筛选时间范围内，状态为“受理中”的工单量" placement="bottom-start">
                                    <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                                </el-tooltip>
                            </p>
                            <p class="number_box">
                                <span class="number2">{{formatNumber(orderData.run_count || 0)}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="order_number_item">
                        <img class="order_img" src="../../../assets/images/overview/end.png" alt="">
                        <div class="order_data">
                            <p class="name">
                                <span>已完结工单量</span> 
                                <el-tooltip popper-class="shadow" effect="light" content="筛选时间范围内，已完结的工单量" placement="bottom-start">
                                    <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                                </el-tooltip>
                            </p>
                            <p class="number_box">
                                <span class="number3">{{formatNumber(orderData.end_count || 0)}}</span>
                                <span class="percentage">{{'工单完结率' + (orderData.create_count ? (orderData.end_count/orderData.create_count * 100).toFixed(2) + '%' : '0%')}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="order_number_item">
                        <img class="order_img" src="../../../assets/images/overview/record.png" alt="">
                        <div class="order_data">
                            <p class="name">
                                <span>售后登记工单量</span> 
                                <el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                                    <div slot="content">
                                        <el-form label-position="left" label-width="120px">
                                            <el-form-item label="售后登记工单量">
                                                <span>筛选时间内，新建工单中有售后登记（退货/换货/补发配件/维修）的工单数量</span>
                                            </el-form-item>
                                            <el-form-item label="登记率">
                                                <span>售后登记工单量/新建工单量</span>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                    <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                                </el-tooltip>
                            </p>
                            <p class="number_box">
                                <span class="number4">{{formatNumber(orderData.after_count || 0)}}</span>
                                <span class="percentage">{{'登记率 ' + (orderData.after_rate ? (orderData.after_rate) : '0%')}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="area_box">
                <div class="order_problem">
                    <div class="pie_box">
                        <div class="pie noTop">
                            <div class="source">
                                <div class="title subtitle">工单问题责任方占比</div>
                                <div class="pie_area data_area">
                                    <div class="echarts_box" ref="sourcePie" >
                                    </div>
                                    <div class="dataNone pie_none" v-show="!this.orderData.source_num || this.orderData.source_num.length == 0">暂无数据</div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="pie model_box noTop">
                            <div class="model">
                                <div class="title subtitle">产品型号占比</div>
                                <div class="pie_area data_area">
                                    <div class="echarts_box" ref="modelPie" >
                                    </div>
                                    <div class="dataNone pie_none" v-show="!this.orderData.type_num || this.orderData.type_num.length == 0">暂无数据</div>
                                </div>
                            </div>
                        </div>

                        <div class="pie ">
                            <div class="afterSale">
                                <div class="title subtitle">售后方式占比</div>
                                <div class="pie_area data_area">
                                    <div class="echarts_box" ref="afterSalePie" >
                                    </div>
                                    <div class="dataNone pie_none" v-show="!this.orderData.after_name || this.orderData.after_name.length == 0">暂无数据</div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="pie">
                            <div class="register">
                                <div class="title subtitle">售后登记工单产品型号占比</div>
                                <div class="pie_area data_area">
                                    <div class="echarts_box" ref="registerPie" >
                                    </div>
                                    <div class="dataNone pie_none" v-show="!this.orderData.after_type_name || this.orderData.after_type_name.length == 0">暂无数据</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="leaderboard">
                        <div class="title subtitle">
                            <span>工单问题分类排行top 10</span>
                            <el-select v-model="getWorkProblemData.product_type" clearable placeholder="全部型号">
                                <el-option :label="item" :value="item" v-for="item in productTypes" :key="item + '75745'"></el-option>
                            </el-select>
                        </div>
                        <div class="leaderboard_box data_area">
                            <div class="leaderboard_item" v-for="(item, i) in orderData.cate_names" :key="item + i + 214234">
                                <div class="label">
                                    <span class="serial" :class="'serial-' + (i+1)">{{i + 1}}</span>
                                    <span class="name ellipsis">{{item}}</span>
                                </div>
                                <span class="number">{{orderData.cate_num[i] || 43243}}</span>
                            </div>
                            <div class="dataNone leaderboard_none" v-show="!orderData.cate_names || orderData.cate_names.length == 0">暂无数据</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="area_box trend">
                <div class="trend_box">
                    <div class="trend_top padding">
                        <div class="title">
                            <span>新建工单量和完结工单量趋势</span>
                            <el-tooltip popper-class="shadow" effect="light" content="筛选时间范围内，统计新建工单量和完结工单的趋势变化" placement="bottom-start">
                                <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                            </el-tooltip>
                        </div>
                        <div class="search_box">
                            <el-form label-position="left" label-width="100px">
                                <el-form-item label="统计指标">
                                    <el-radio-group v-model="trendType" size="small">
                                        <el-radio-button label="create">新建工单量</el-radio-button>
                                        <el-radio-button label="end">完结工单量</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="日期选择">
                                    <DatePicker :date="trendTime" max="120" @dateSelect="trendDateSelect"></DatePicker>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="line"></div>
                        <div class="padding line_echart">
                            <div class="select_show_type">
                                <el-radio-group v-model="getTrendData.data_type" size="small">
                                    <el-radio-button label="TypeDay">日</el-radio-button>
                                    <el-radio-button label="TypeWeek" :disabled="!(selectType > 1)">周</el-radio-button>
                                    <el-radio-button label="TypeMonth" :disabled="!(selectType > 2)">月</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="echart_line_area data_area">
                                <div class="line_box" ref="line_echart">

                                </div>
                                <div class="dataNone pie_none line_none" v-show="!this.trendData.keyList || this.trendData.keyList.length == 0">暂无数据</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="area_box">
                <div class="trend_table">
                    <div class="title subtitle">
                        <span>数据明细</span>
                    </div>
                    <div class="line"></div>
                    <el-table
                        highlight-current-row
                        :data="trendTableData">
                        <el-table-column prop="date" label="日期" ></el-table-column>
                        <el-table-column prop="create" label="新建工单量" ></el-table-column>
                        <el-table-column prop="end" label="完结工单量" ></el-table-column>
                    </el-table>
                    <Pagination :total="total" :page="page" @paginationChange="initTableData"></Pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import resize  from "../../../minxins/resize"
export default({
    name: 'overview',
    mixins: [resize],
    data() {
        return {
            product_id:'',
            product: [],
            productTypes: [],
            overviewTime: [],
            getWorkProblemData: {
                start_time: 0,
                end_time: 0,
                product_type: ''
            },
            orderData: {},
            getTrendData: {
                start_time: 0,
                end_time: 0,
                data_type: 'TypeDay',
                zone: this.timezone
            },
            selectType: 3,
            trendData: {},
            trendType: 'create',
            trendTime: [],
            trendTableData: [],
            page_size: 10,
            page: 1,
            total: 0,
        }
    },
    watch: {
        'overviewTime' : function (nTime) {
            this.getWorkProblemData.start_time = nTime[0] || 0;
            this.getWorkProblemData.end_time = nTime[1] || 0;
            if(this.getWorkProblemData.product_id) {
                this.getWorkProblem();
            }
        },
        'trendTime' : function (nTime, oTime) {
            if(nTime[1] - nTime[0] < 86400000 * 7) { //选择7天内 
                this.selectType = 1;
                this.getTrendData.data_type = 'TypeDay';
            }else if(nTime[1] - nTime[0] < 86400000 * 30) { //选择30天内 
                this.selectType = 2;
                if(this.getTrendData.data_type == 'TypeMonth') {
                    this.getTrendData.data_type = 'TypeWeek';
                }
            }else{
                this.selectType = 3;
            }

            this.getTrendData.start_time = nTime[0];
            this.getTrendData.end_time = nTime[1];
            if(this.getTrendData.product_id) {
                this.getOrderNumber();
            }
        },
        product_id: function(nId) {
            this.product.forEach(item => {
                if(item.product_id == nId){
                    this.productTypes = item.productTypes;
                    return;
                }
            })
            this.getWorkProblemData.product_type =  '';
            this.getWorkProblem();
            this.getOrderNumber();
        },
        trendType: function() {
            this.initLine();
        },
        'getTrendData.data_type': function() {
            this.getOrderNumber();
        },
        'getWorkProblemData.product_type': function() {
            this.getWorkProblem();
        }
    },
    created() {
        this.getProductCate();
    },
    methods: {
        dateSelect(date) {
            this.overviewTime = date ? [...date] : '';
        },
        trendDateSelect(date) {
            this.trendTime = [...date];
        },
        getProductCate() {
            this.api.getProductCate({}).then(data => {
                this.product = data.data.productCateInfos;
                if(this.product.length > 0) {
                    this.product_id = this.product[0].product_id;
                }
                this.overviewTime = this.setDate(7);
                this.trendTime = this.setDate(30);
            })
        },
        getWorkProblem() {
            this.getWorkProblemData.product_id = this.product_id;
            this.api.getWorkProblem(this.getWorkProblemData).then(data => {
                this.orderData = data.data;
                this.initPie();
            })
        },
        getOrderNumber() {
            this.getTrendData.product_id = this.product_id;
            this.api.getOrderNumber(this.getTrendData).then(data => {
                this.trendData = data.data;
                this.total = data.data.createList.length;
                this.initLine();
                this.initTableData({page_size: this.page_size, page: 1});
            })
        },
        initTableData(data) {
            this.trendTableData = [];
            this.page = data.page;
            this.page_size = data.page_size;
            for(let i=(data.page_size * (data.page - 1)); i<this.trendData.keyList.length; i++) {
                this.trendTableData.push({
                    date: this.trendData.keyList[i],
                    create: this.trendData.createList[i],
                    end: this.trendData.endList[i],
                });
                if(this.trendTableData.length == data.page_size) break;
            }
        },
        initEcharts() {
            var lineChart = this.echarts.init(this.$refs.line_echart);
            lineChart.resize();
        },
        initPie() {
            let sourceTotal = 0, modelTotal = 0, afterSaleTotal = 0, registerTotal = 0;
            let sourceData = [], modelData = [], afterSaleData = [], registerData = [];
            for(let i=0; i< this.orderData.source_num.length; i++) {
                if(i == 9) {
                    sourceData.push({ value: this.orderData.source_num[i], name: '其他', per: Number(this.orderData.source_per[i]) });
                    sourceTotal += this.orderData.source_num[i];
                }else if(i > 9){
                    sourceData[9].value += this.orderData.source_num[i];
                    sourceData[9].per = (Number(sourceData[9].per) +  Number(this.orderData.source_per[i])).toFixed(2);
                    sourceTotal += this.orderData.source_num[i];
                }else{
                    sourceData.push({value: this.orderData.source_num[i], name: this.orderData.source_names[i], per: this.orderData.source_per[i]});
                    sourceTotal += this.orderData.source_num[i];
                }
            }
            for(let i=0; i< this.orderData.type_num.length; i++) {
                if(i == 9) {
                    modelData.push({ value: this.orderData.type_num[i], name: '其他', per: Number(this.orderData.type_per[i]) });
                    modelTotal += this.orderData.type_num[i];
                }else if(i > 9){
                    modelData[9].value += this.orderData.type_num[i];
                    modelData[9].per = (Number(modelData[9].per) +  Number(this.orderData.type_per[i])).toFixed(2);
                    modelTotal += this.orderData.type_num[i];
                }else{
                    modelData.push({value: this.orderData.type_num[i], name: this.orderData.type_names[i], per: this.orderData.type_per[i]});
                    modelTotal += this.orderData.type_num[i];
                }
            }
            for(let i=0; i< this.orderData.after_num.length; i++) {
                afterSaleData.push({value: this.orderData.after_num[i], name: this.orderData.after_name[i], per: this.orderData.after_per[i]});
                afterSaleTotal += this.orderData.after_num[i];
            }
            for(let i=0; i< this.orderData.after_type_num.length; i++) {
                if(i == 9) {
                    registerData.push({ value: this.orderData.after_type_num[i], name: '其他', per: Number(this.orderData.after_type_per[i]) });
                    sourceTotal += this.orderData.after_type_num[i];
                }else if(i > 9){
                    registerData[9].value += this.orderData.after_type_num[i];
                    registerData[9].per = (Number(registerData[9].per) +  Number(this.orderData.after_type_per[i])).toFixed(2);
                    registerTotal += this.orderData.after_type_num[i];
                }else{
                    registerData.push({value: this.orderData.after_type_num[i], name: this.orderData.after_type_name[i], per: this.orderData.after_type_per[i]});
                    registerTotal += this.orderData.after_type_num[i];
                }
                
            }
            var sourceChart = this.echarts.init(this.$refs.sourcePie);
            sourceChart.clear();
            sourceChart.setOption(this.pieOption(sourceData, sourceTotal));

            var modelChart = this.echarts.init(this.$refs.modelPie);
            modelChart.clear();
            modelChart.setOption(this.pieOption(modelData, modelTotal));

            var afterSaleChart = this.echarts.init(this.$refs.afterSalePie);
            afterSaleChart.clear();
            afterSaleChart.setOption(this.pieOption(afterSaleData, afterSaleTotal));

            var registerChart = this.echarts.init(this.$refs.registerPie);
            registerChart.clear();
            registerChart.setOption(this.pieOption(registerData, registerTotal));
        },
        initLine() {
            var lineChart = this.echarts.init(this.$refs.line_echart);
            lineChart.clear();
            lineChart.setOption(this.lineOption());
        },
        pieOption(data, total) {
            return {
                color: ['#507FF7', '#64DE2F', '#FF9841', '#9B56FF', '#46FAF8'],
                title: {
                    text: `{name|工单量}\n{val|${total}}`,
                    top: '40%',
                    left: '64',
                    textStyle: {
                        rich: {
                            name: {
                                fontSize: 20,
                                color: '#666',
                                lineHeight: '30',
                                align: 'center'
                            },
                            val: {
                                fontSize: 20,
                                color: '#000',
                                lineHeight: '30',
                                align: 'center'
                            }
                        }
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b0}: <br /> {d0} % '
                },
                legend: {
                    orient: 'vertical',
                    left: '210px',
                    top: 'center',
                    itemWidth: 12,
                    itemHeight: 12,
                    icon: "circle",
                    itemGap: 10,
                    selectedMode: false,
                    overflow: 'truncate',
                    formatter: function (name) {
                        let legendData;
                        for(let i=0; i<data.length; i++) {
                            if(data[i].name == name) {
                                legendData = data[i];
                                break;
                            }
                        }
                        if(legendData) {
                            return `{name|${legendData.name.length > 6 ? legendData.name.substring(0,6) + '...' : legendData.name}} \t\t{per|${legendData.per} %} ${legendData.value}`;
                        }
                        return '';
                    },
                    textStyle: {
                        fontSize: 12,
                        rich: {
                            name: {
                                fontSize: 12,
                                width: 90,
                            },
                            per: {
                                width: 60
                            }
                        }
                    }
                    
                },
                series: [
                    {
                        name: '工单问题责任方占比',
                        type: 'pie',
                        center: ['100px', 'center'],
                        radius: ['55', '80'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            // borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center',
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '20'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data
                    }
                ]
            };
        },
        lineOption() {
            let xData = [...this.trendData.keyList];
            xData.reverse();
            let yData = [...this.trendData[this.trendType + 'List']].reverse();
            return {
                grid: {
                    left: 20,
                    top: 40,
                    bottom: 10,
                    right: 40,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData,
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function(item, index) {
                            return item.split('~')[0]
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    splitNumber: 5,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                    axisLine: {
                        show: false
                    }
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    backgroundColor: 'rgba(255,255,255,.9)',
                    orderWidth: 0,
                    textStyle: {
                        color: '#333'
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            type: 'solid',
                            color: 'rgba(200,200,200,.4)'
                        }
                    },
                    formatter: `{b} <br /> ${this.trendType == 'create' ? '新建工单量' : '完结工单量'}: {c}`,

                },
                series: [
                    {
                        data: yData,
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        lineStyle: {
                            color: '#5192FF',
                            width: 1
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y:1,
                                x2: 0,
                                y2: 0,
                                colorStops: [{
                                    offset: 0, color: '#FFFFFF' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#5192FF' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        }
                    }
                ]
            }
        }
    }
})
</script>
<style lang="less" scoped>
    @import '../../../less/overview.less';
</style>



// WEBPACK FOOTER //
// src/view/order/overview/overview.vue